import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class EventBusService {
    private filterAssessmentAnswersTextSubject = new Subject<any>();
    private filterAssessmentAnswersSubject = new Subject<any>();
    private assessmentValidationErrorsClearedSubject = new Subject<any>();
    private assessmentValidationExpandedSubject = new Subject<any>();
    private assessmentValidationCollapsedSubject = new Subject<any>();
    private assessmentValidationVisibleSubject = new Subject<any>();
    private assessmentNavigatorItemSelectedSubject = new Subject<any>();
    private loaderSubject = new Subject<any>();

    constructor() {
    }

    sendLoaderSubjectEvent(loading, message) {
        const loadingEvent = { loading: loading, message: message };

        this.loaderSubject.next(loadingEvent);
    }

    getLoadingEvents() {
        return this.loaderSubject.asObservable();
    }

    sendFilterAssessmentAnswersTextEvent(textFilter) {
        this.filterAssessmentAnswersTextSubject.next(textFilter);
    }

    getFilterAssessmentAnswersTextEvents() {
        return this.filterAssessmentAnswersTextSubject.asObservable();
    }

    sendFilterAssessmentAnswersEvent(values) {
        this.filterAssessmentAnswersSubject.next(values);
    }

    getFilterAssessmentAnswersEvents() {
        return this.filterAssessmentAnswersSubject.asObservable();
    }

    sendAssessmentValidationErrorsClearedEvent() {
        this.assessmentValidationErrorsClearedSubject.next(null);
    }

    getAssessmentValidationErrorsClearedEvents() {
        return this.assessmentValidationErrorsClearedSubject.asObservable();
    }

    sendAssessmentValidationExpandedEvent() {
        this.assessmentValidationExpandedSubject.next(null);
    }

    getAssessmentValidationExpandedEvents() {
        return this.assessmentValidationExpandedSubject.asObservable();
    }

    sendAssessmentValidationCollapsedEvent() {
        this.assessmentValidationCollapsedSubject.next(null);
    }

    getAssessmentValidationCollapsedEvents() {
        return this.assessmentValidationCollapsedSubject.asObservable();
    }

    sendAssessmentValidationVisibleEvent() {
        this.assessmentValidationVisibleSubject.next(null);
    }

    getAssessmentValidationVisibleEvents() {
        return this.assessmentValidationVisibleSubject.asObservable();
    }

    sendAssessmentNavigatorItemSelectedEvent(value) {
        this.assessmentNavigatorItemSelectedSubject.next(value);
    }

    getAssessmentNavigatorItemSelectedEvents() {
        return this.assessmentNavigatorItemSelectedSubject.asObservable();
    }
}
